module.exports = __webpack_public_path__ + "static/media/tutorial-8.3513ad4d.jpg";